import * as React from 'react';
import UcmaChatView from '../components/UcmaChatView';
import { lazyShowFlexPane } from 'owa-flex-pane';
import { getStore } from '../store/chatStore';

let isSidePaneShowing = false;

export default function showSidePane() {
    const chats = getStore().chats;
    const chat = chats[chats.length - 1];
    if (!isSidePaneShowing && chat) {
        lazyShowFlexPane
            .importAndExecute(<UcmaChatView />, {
                overlayOnSmallWidth: false,
                onDismiss: () => {
                    isSidePaneShowing = false;
                },
            })
            .then(() => {
                isSidePaneShowing = true;
            });
    }
}
